import type React from "react";
import { ReactComponent as Svg } from "./assets/game-controller.svg";
import * as styles from "./Icon.module.scss";

type GameControllerProps = React.SVGProps<SVGSVGElement>;

export const GameController = ({ className, ...props }: GameControllerProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
